import { render, staticRenderFns } from "./Warranties.vue?vue&type=template&id=252ceda3&scoped=true&"
import script from "./Warranties.js?vue&type=script&lang=js&"
export * from "./Warranties.js?vue&type=script&lang=js&"
import style0 from "./Warranties.scss?vue&type=style&index=0&id=252ceda3&lang=scss&scoped=true&"
import style1 from "./Warranties.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ceda3",
  null
  
)

export default component.exports